import cx from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "reactstrap";

import { deleteAlertAction } from "@/redux/alerts/alerts.actions";
import { alertsSelector } from "@/redux/alerts/alerts.selectors";

import Button from "../common/Button/Button";

// eslint-disable-next-line css-modules/no-unused-class
import styles from "./Alerts.module.scss";

const Alerts = () => {
  const dispatch = useDispatch();
  const alerts = useSelector(alertsSelector);

  const closeAlertHandler = (alertId) => {
    dispatch(deleteAlertAction(alertId));
  };

  const timerCloseHandler = (alertId) => {
    // Close the alert after 5 seconds
    setTimeout(() => {
      closeAlertHandler(alertId);
    }, 10000);
  };

  return (
    <div className={styles.alerts}>
      {alerts.map((alert) => (
        <Alert
          key={alert.id}
          className={cx(styles.alert, {
            [styles.alertDark]: alert.type === "dark",
            [styles.alertDanger]: alert.type === "danger",
            [styles.alertSuccess]: alert.type === "success",
            [styles.alertInfo]: alert.type === "info",
            [styles.alertWarning]: alert.type === "warning",
          })}
          data-testid="alert"
          isOpen
          toggle={() => closeAlertHandler(alert.id)}
        >
          {alert.warnings?.length ? (
            // Accounting "Fix" warnings: render plaintext + action link as a button,
            // never HTML. Falls back to the message path for all other alerts.
            <div>
              {alert.warnings.map((warning, index) => (
                <div key={warning.code ? `${warning.code}-${index}` : index}>
                  {warning.detail}{" "}
                  {warning.action?.href && (
                    <a href={warning.action.href} className={cx(styles.alertButton, alert.buttonClass)}>
                      {warning.action.label || "Fix"}
                    </a>
                  )}
                </div>
              ))}
            </div>
          ) : (
            // biome-ignore lint/security/noDangerouslySetInnerHtml: pre-existing; existing callers pass HTML in alert.message. Removing it is a behaviour change tracked outside F11 (see docs/claude/error-handling.md).
            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
          )}
          {alert.autoclose && timerCloseHandler(alert.id)}
          {alert.buttonText && (
            <Button
              className={cx(styles.alertButton, alert.buttonClass)}
              onClick={() => {
                alert.callback();
                closeAlertHandler(alert.id);
              }}
            >
              {alert.buttonText}
            </Button>
          )}
        </Alert>
      ))}
    </div>
  );
};

export default Alerts;
